import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Configurer from "../../components/Configurer";

import DataGrid from "../../components/DataGrid";

import AdminModule from "../../components/boxes/AdminModule";
import { adminPages } from "../../variables/adminPages";
import WidgetComponents from "../../components/widgets/WidgetComponents";
import { adminWidgets } from "../../variables/adminWidgets";
import { energyWidgets } from "../../variables/energyWidgets";
import { carbonPages } from "../../variables/carbonPages";
import { checkPermission, checkTextTranslation, checkTranslation } from "../../utils/useful";
import { carbonWidgets } from "../../variables/carbonWidgets";


class AdminWidgetsPage extends React.Component {


    state = {
        // info: {
        modules: []
        // }
    }


    componentDidMount() {
        // console.log('this.props.widget', this.props.widget)

        this.setState({ modules: Object.values(adminWidgets) })

        // this.setState({ modules: Object.values(adminWidgets) })
    }
    componentDidUpdate(prevProps) {
        if (this.props.widget != prevProps.widget) {
            console.log('this.props.widget', this.props.widget)
            if (this.props.widget == 'adminPages') {
                this.setState({ modules: Object.values(adminWidgets) })
            } else if (this.props.widget == 'energyPages') {
                this.setState({ modules: Object.values(energyWidgets) })
            } else if (this.props.widget == 'energyPages') {
                this.setState({ modules: Object.values(carbonWidgets) })
            }
        }
    }




    render() {
        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: this.props.title, button: {} }}
                title={this.props.title}
                description={this.props.description}
                className=""

            >

                <div className={"row m-0"} >

                    <div className="col-12 pt-0 pb-4 ">

                        {/* <div className="px-0 mt-0 mb-4">
                            <p className="text-ultra-big " style={{ fontWeight: '500', color: '#222' }}>{checkTextTranslation(this.props.title)}</p>
                            <p className="text-small mt-2" style={{ color: '#456' }}>{checkTextTranslation(this.props.description)}</p>
                        </div> */}

                        <div className="row m-0">

                            {this.state.modules?.map((prop) => {
                                let Component = WidgetComponents[prop.key]
                                // if (Component && checkPermission(prop.permissionParent + '.view')) {
                                if (Component && true) {

                                    let variables = {
                                        permissionRoot: prop.permissionParent
                                    }

                                    return (
                                        <div className={"w-100 mb-1 p-1 col-12  col-md-" + (prop.col ?? "6")} key={prop._id}>
                                            <div className="h-100 p-4 px-1 d-flex flex-column custom-scrollbar-widget" style={{ backgroundColor: '#fff', borderRadius: 10, boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px', maxHeight: '400px', minHeight: '400px', overflow: 'auto' }}>
                                                <p className="text-start text-bold mt-2 mb-3 text-normal">{checkTranslation(prop.title)}</p>
                                                <Component widget={prop} dashboard={this.state.info} variables={variables} />
                                            </div>
                                        </div>
                                    )
                                }
                            })}
                        </div>

                        {/* <DataGrid isLoading={this.state.isLoading} data={this.props.modules} component={AdminModule} col="col-12 col-sm-6 col-md-6 col-lg-3" settings={{route:this.props.route}} /> */}
                    </div>
                </div>
            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminWidgetsPage);
